export default {
  state: {
    conferencePram: { datatype: "", key:"" } //远程鉴定查询条件
  },
  mutations: {
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/vuex/queryParam.js